export default "__VITE_ASSET__CT8A99Sv__"